import 'vite/modulepreload-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './style.css';

declare global {
  interface Window {
    wpSitebotSettings?: {
      restUrl: string;
      nonce: string;
      agentHost: string;
    };
  }
}

const rootElement = document.getElementById('wp-sitebot-widget-root');

if (rootElement) {
  createRoot(rootElement).render(
    <React.StrictMode>
      <App settings={window.wpSitebotSettings} />
    </React.StrictMode>
  );
}
